// Sample card from Airbnb
import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import { Alert } from 'react-bootstrap';
import "react-datepicker/dist/react-datepicker.css";
import APIConfig from "../../../../api/APIConfig";
import swal from 'sweetalert';
import classes from "./styles.module.css"; 

import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    useColorModeValue,
    FormControl,
    FormLabel,
    Input,
    Select,
} from '@chakra-ui/react';

function formatDate(string){
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(string).toLocaleDateString([],options);
  }

function FormDataPribadiPeserta() {
    const navigate = useNavigate();
    const [namaPeserta, setNamaPeserta] = useState('');
    const [jenisKelaminPeserta, setJenisKelaminPeserta] = useState('');
    const [tempatKelahiranPeserta, setTempatKelahiranPeserta] = useState('');
    const [tanggalKelahiranPeserta, setTanggalKelahiranPeserta] = useState('');
    const [validation, setValidation] = useState({});
    const { id } = useParams();

    useEffect(() => {
        getPesertaById();
        
    }, []);
    
    const getPesertaById = async() => {
        const response = await APIConfig.get(`/v1/peserta/${id}`);
        const data = await response.data
        setNamaPeserta(data.namaPeserta);
        setJenisKelaminPeserta(data.jenisKelaminPeserta);
        setTempatKelahiranPeserta(data.tempatKelahiranPeserta);
        setTanggalKelahiranPeserta(formatDate(data.tanggalKelahiranPeserta));
        console.log(data.namaPeserta)
    };

    const updateDataPribadi = async (e) => {
        e.preventDefault();
        console.log("masuk")       
        swal("Apakah Anda yakin ingin mengubah data pribadi?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                APIConfig.put(`v1/dataPribadi/peserta/${id}`, {
                    namaPeserta: namaPeserta
                })
                swal({
                    title: "Data pribadi berhasil tersimpan!",
                    icon: "success",
                    button: "OK",
                })
                .then(() => {
                    navigate(`/peserta/profile/datapribadi/${id}`)
                })
                .catch((error) => {
                    console.log(error);
                    setValidation(error.response.data);
                })
            }
            return false;
        });
    };


    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Profil
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                bg={useColorModeValue('white', 'gray.900')}
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        color={useColorModeValue('gray.700', 'white')}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Data Pribadi
                    </Heading>
                    
                    {
                        validation.errors &&
                            <Alert variant="danger">
                                <ul class="mt-0 mb-0">
                                    { validation.errors.map((error, index) => (
                                        <li key={index}>{ `${error.param} : ${error.msg}` }</li>
                                    )) }
                                </ul>
                            </Alert>
                    }
                    
                    <Form p={6} onSubmit={updateDataPribadi}>

                        <FormControl pb={6} isRequired fontFamily={'Inter'} >
                        <FormLabel htmlFor='namalengkap'>Nama Lengkap</FormLabel>
                        <Input 
                            id='namalengkap' 
                            placeholder='Masukkan nama lengkap'
                            value={namaPeserta}
                            onChange={(e) => setNamaPeserta(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='jeniskelamin'>Jenis Kelamin</FormLabel>
                        <Select 
                        isDisabled
                        id='jeniskelamin' 
                        placeholder='Pilih jenis kelamin'
                        value={jenisKelaminPeserta}
                        onChange={(e) => setJenisKelaminPeserta(e.target.value)}>
                            <option value={0}>Perempuan</option>
                            <option value={1}>Laki-laki</option>
                        </Select>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='tempatlahir'>Tempat Lahir</FormLabel>
                        <Input 
                        isDisabled
                        id='tempatlahir' 
                        placeholder='Masukkan tempat lahir'
                        value={tempatKelahiranPeserta}
                        onChange={(e) => setTempatKelahiranPeserta(e.target.value)} />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tanggallahir'>Tanggal Lahir</FormLabel>
                        <div>
                            <style>
                                {`.date-picker input {
                                    width: 100%;
                                    height: 40px;
                                    padding-left: 17px;
                                    border: 1px solid #E2E8F0;
                                    border-radius: 5px;}
                                .date-picker focus {
                                    border-color:#cd3232;
                                }
                                `}
                            </style>
                            <Input 
                                isDisabled
                                id='tanggallahir' 
                                placeholder='Masukkan tanggal lahir'
                                value={tanggalKelahiranPeserta}
                                onChange={(e) => setTanggalKelahiranPeserta(e.target.selected)}/>
                        </div>
                        </FormControl>

                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default FormDataPribadiPeserta;